import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchMenusData } from "../features/menus/menusSlice";

function Sidebar() {
    const dispatch = useDispatch();
    const {menus, loading, error} = useSelector((state) => state.menus)

    useEffect(() => {
        dispatch(fetchMenusData())
    }, [dispatch])

    return (
        <div className="w-265 d-lg-block d-none flex-shrink-0">
            <div className="responsive-dropdown style-two common-dropdown nav-submenu p-0 submenus-submenu-wrapper shadow-none border border-gray-100 position-relative border-top-0">
                <button
                    type="button"
                    className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                >
                    <i className="ph ph-x" />{" "}
                </button>
                <div className="logo px-16 d-lg-none d-block">
                    <Link to="/" className="link">
                        <img src="assets/images/logo/logo.png" alt="Logo" />
                    </Link>
                </div>
                <ul className="responsive-dropdown__list scroll-sm p-0 py-8 overflow-y-auto">
                    {menus?.menus?.map((menu) => (
                        <li key={menu.id} className="has-submenus-submenu">
                        <Link
                            to={`/product/category/${menu.id}?withproduct=1`}
                            className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                        >
                            <span>{menu?.name?.en}</span>
                            {menu?.menus?.length > 0 && (
                            <span className="icon text-md d-flex ms-auto">
                                <i className="ph ph-caret-right" />
                            </span>
                            )}
                        </Link>

                        {menu?.menus?.length > 0 && (
                            <div className="submenus-submenu py-16">
                            <h6 className="text-lg px-16 submenus-submenu__title">
                                {menu?.name?.en}
                            </h6>

                            <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                {menu.menus.map((subMenu) => (
                                <li key={subMenu.id}>
                                    <Link to={`/product/category/${subMenu.id}?withproduct=1`}>
                                    {subMenu?.title?.en}
                                    </Link>
                                </li>
                                ))}
                            </ul>
                            </div>
                        )}
                        </li>
                    ))}
                    </ul>
            </div>
        </div>
    )
}

export default Sidebar;